import { roundCents } from '@/shared'
import { roundQuantity } from './roundQuantity'

export const calculateLineItemTotalInCents = (quantity: number, rateInCents: number) => (
  Math.round(roundQuantity(quantity) * roundCents(rateInCents))
)
